class menuMobileCLX extends HTMLElement {
  constructor() {
    super();
    this.icon_go_menus = this.querySelectorAll('[data-click-icon]');
    this.back_icons = this.querySelectorAll('[back-icon]');
  }
  connectedCallback() {
    this.icon_go_menus.forEach(icon => {
      icon.addEventListener('click', this.handleClickIcon.bind(this));
    });
    this.back_icons.forEach(back => {
      back.addEventListener('click', this.handleClickBackIcon.bind(this));
    });
  }
  handleClickIcon(e) {
    const target = e.target;
    let menu_child_id = target.getAttribute('aria-controls');
    let menu_child = document.getElementById(menu_child_id);
    if(menu_child){
      menu_child.style.setProperty('opacity', 1);
      menu_child.style.setProperty('pointer-events', 'auto');
    }
  }
  handleClickBackIcon(e) {
    const target = e.target;
    let menu_id = target.getAttribute('aria-controls');
    let menu_el = document.getElementById(menu_id);
    if(menu_el){
      menu_el.style.setProperty('opacity', 0);
      menu_el.style.setProperty('pointer-events', 'none');
    }
  }
}

customElements.define('clx-menu-mobile', menuMobileCLX);


class bannerItemTab extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.tab_content = this.querySelector('[data-content]');
    this.tab_content.style.setProperty('min-height', this.tab_content.scrollHeight + 'px');
  }
}

customElements.define('clx-banner-item', bannerItemTab);


window.addEventListener('scroll', function(){
  let slideshow = document.querySelector('.clx-slideshow-pro');
  if(slideshow){
    let scrollTop = window.scrollY;
    if(scrollTop - slideshow.clientHeight > 100){
      slideshow.style.setProperty('opacity', '0');
      slideshow.style.setProperty('pointer-events', 'none');
    }else{
      slideshow.style.setProperty('opacity', '1');
      slideshow.style.setProperty('pointer-events', 'auto');
    }
  }
});



// Swiper.js
// Define the Web Component
class LeLaboSlider extends HTMLElement {
  constructor() {
      super();
  }

  // connectedCallback runs when the element is added to the DOM.
  // Since the HTML is already present, we just need to initialize the slider logic.
  connectedCallback() {
      this.initSlider();
  }

  // Method to initialize Swiper instances and event listeners on the existing HTML
  initSlider() {
      // Select elements within this component
      const mainSlider = this.querySelector('.main-slider');
      const thumbsSlider = this.querySelector('.thumbs-slider');
      const breakpoint = 768;

      if (!mainSlider || !thumbsSlider) {
          console.error('Slider elements not found inside <le-labo-slider>.');
          return;
      }

      const commonParams = { loop: true, spaceBetween: 0 };

      const thumbsSliderParams = {
          ...commonParams,
          freeMode: true,
          watchSlidesProgress: true,
          breakpoints: { 0: { slidesPerView: 1 }, [breakpoint + 1]: { slidesPerView: 4 } }
      };
      
      Object.assign(thumbsSlider, thumbsSliderParams);
      thumbsSlider.initialize();
      
      let effectParams = {};
      if(window.innerWidth > breakpoint){
        effectParams = { effect: 'fade', fadeEffect: { crossFade: true }}
      }else{
        effectParams = { effect: 'slide'}
      }

      const mainSliderParams = {
          ...commonParams,
          // thumbs: { swiper: thumbsSlider.swiper },
          ...effectParams,
          pagination: {
            clickable: true,
            dynamicBullets: true
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
      };
      // console.log(mainSliderParams)
      Object.assign(mainSlider, mainSliderParams);
      mainSlider.initialize();
      
      const thumbSlides = this.querySelectorAll('.thumbs-slider swiper-slide');
      thumbSlides.forEach((slide) => {
          slide.addEventListener('mouseenter', () => {
              if (window.innerWidth > breakpoint) {
                  const realIndex = parseInt(slide.dataset.swiperSlideIndex, 10);
                  if (mainSlider.swiper && !isNaN(realIndex)) {
                      mainSlider.swiper.slideToLoop(realIndex);
                  }
              }
          });
      });
  }
}

// Register the new custom element with the browser
customElements.define('le-labo-slider', LeLaboSlider);